import { SHA256Hash } from './SHA256Hash';

/**
 * Generates a SHA-256 hash for the given message string.
 *
 * @param {string} message - The input string to hash. Must not be empty.
 */
export async function sha256Hash(message: string): Promise<SHA256Hash> {
  if (!message) {
    throw new Error('Cannot hash an empty input');
  }

  const msgBuffer = new TextEncoder().encode(message);
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));

  return new SHA256Hash(
    hashArray.map((b) => b.toString(16).padStart(2, '0')).join(''),
  );
}
